"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  types: true,
  rpc: true,
  typesAlias: true,
  typesBundle: true,
  signedExtensions: true
};
exports.typesBundle = exports.typesAlias = exports.types = exports.signedExtensions = exports.rpc = void 0;

var _typeDefinitions = require("@acala-network/type-definitions");

require("./interfaces/augment-api");

require("./interfaces/augment-api-consts");

require("./interfaces/augment-api-query");

require("./interfaces/augment-api-rpc");

require("./interfaces/augment-api-tx");

require("./interfaces/augment-types");

var _augmentApiMobx = require("./interfaces/augment-api-mobx");

Object.keys(_augmentApiMobx).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _augmentApiMobx[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _augmentApiMobx[key];
    }
  });
});
const types = _typeDefinitions.types;
exports.types = types;
const rpc = _typeDefinitions.rpc;
exports.rpc = rpc;
const typesAlias = _typeDefinitions.typesAlias;
exports.typesAlias = typesAlias;
const typesBundle = _typeDefinitions.typesBundle;
exports.typesBundle = typesBundle;
const signedExtensions = _typeDefinitions.signedExtensions;
exports.signedExtensions = signedExtensions;